/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { getUproColor } from "utils/colors";
import { makeNiceText } from "utils/formatters";

const getRows = (data, accion) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        id: (
          <SoftBox ml={2}>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="bold"
            >
              {item?.id}
            </SoftTypography>
          </SoftBox>
        ),
        nombre: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="bold"
            >
              {makeNiceText(item?.nombre)}
            </SoftTypography>
          </SoftBox>
        ),
        accion: (
          <SoftBox
            mr={2}
            gap={1}
            sx={{
              display: "flex",
            }}
          >
            <Tooltip title="Opciones" placement="top">
              <Icon
                // color="dark"
                fontSize="small"
                sx={{
                  cursor: "pointer",
                  color: getUproColor("uproGreen"),
                }}
                onClick={(event) => accion(event, item)}
              >
                more_vert
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
      });
    });
  }
  return rows;
};

const columns = [
  { name: "id", desc: "ID", align: "left", width: "1%" },
  { name: "nombre", desc: "Nombre", align: "left" },
  { name: "accion", desc: " ", align: "right", width: "1%" },
];

export default { columns, getRows };
